import NewProformaSales from "../../../../components/@documents/proforma_sales/NewProformaSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ProformaSalesNewPage() {

    return (
        <NewProformaSales 
            routeType={routeTypes.admin}
        />
    )
}